import {z} from '@hono/zod-openapi';

export const enhanceMessageRequestSchema = z
  .object({
    channel: z.enum(['sms', 'email', 'chat']).openapi({example: 'email'}),
    body: z
      .string()
      .min(1)
      .max(10000)
      .openapi({example: 'Dobry den, posilame potvrzeni objednavky {{ order.number }}.'}),
    subject: z.string().min(1).max(500).optional().openapi({example: 'vase objednavka'}),
  })
  .refine((data) => data.subject === undefined || data.channel === 'email', {
    message: 'subject is only allowed when channel is "email"',
    path: ['subject'],
  })
  .openapi('EnhanceMessageRequest');

export type EnhanceMessageRequest = z.infer<typeof enhanceMessageRequestSchema>;
